import Formsy from 'formsy-react';
import _ from 'lodash';
import React from 'react';
import {Input} from '../form';
import {login} from '../../actions/SessionActions'

class LoginForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showErrors: false,
      isProcessing: false,
      serverError: null
    };

  }

  onValidSubmit(model) {

    const { onSuccess = _.noop, onError = _.noop } = this.props;
    this.setState({isProcessing: true, serverError: null});

    login(model.email, model.password)
      .then(() => {
        this.setState({isProcessing: false, serverError: null});
        onSuccess();
      })
      .catch((e) => {
        this.setState({isProcessing: false, serverError: e.message});
        onError();
      });

  }

  onInvalidSubmit() {
    this.setState({ showErrors: true });
  }

  render() {

    const { showErrors, isProcessing, serverError } = this.state;

    return (
      <Formsy onValidSubmit={(model) => this.onValidSubmit(model) }
              onInvalidSubmit={() => this.onInvalidSubmit() }>
        <Input name="email"
               type="email"
               icon="envelope"
               label="Email"
               showErrors={showErrors}
               validations="isEmail"
               validationError="This is not a valid email"
               inputSize="pt-large"
               required />
        <Input name="password"
               showErrors={showErrors}
               icon="key"
               label="Password"
               type="password"
               inputSize="pt-large"
               required />
        {serverError && (
          <div className="pt-callout pt-intent-danger s4">
            {serverError}
          </div>
        )}
        {!isProcessing ? (
          <button type="submit" className="pt-button pt-large pt-icon-log-in pt-intent-primary">Submit</button>
        ) : (
          <button type="submit" className="pt-button pt-disabled pt-large pt-icon-log-in">Submitting...</button>
        )}
      </Formsy>
    );
  }
}

export default LoginForm;


// WEBPACK FOOTER //
// ./src/components/forms/LoginForm.js